import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const legalLinks = [
  { href: '/mentions-legales', label: 'Mentions légales' },
  { href: '/politique-de-confidentialite', label: 'Confidentialité' },
  { href: '/cgu', label: 'CGU' },
  { href: '/cookies', label: 'Cookies' },
  { href: '/donnees-personnelles', label: 'Mes données' },
];

export default function LegalLayout({ title, lastUpdated, children }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0f0e17]">
      <header className="sticky top-0 z-50 bg-[#0f0e17]/90 backdrop-blur-xl border-b border-white/5 px-4 py-3">
        <div className="max-w-2xl mx-auto flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="text-[#e8e8e8] hover:text-white transition-colors p-1 rounded-lg hover:bg-white/5"
            aria-label="Retour"
          >
            <ArrowLeft size={20} />
          </button>
          <Link to="/" className="font-heading font-bold text-lg text-white tracking-tight">
            Kurso
          </Link>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-8 pb-16">
        <h1 className="text-3xl font-heading font-bold text-white mb-2">{title}</h1>
        {lastUpdated && (
          <p className="text-sm text-[#a0a0ab] mb-8 pb-6 border-b border-white/10">
            Dernière mise à jour : {lastUpdated}
          </p>
        )}

        <div className="space-y-6 text-[#e8e8e8] text-sm leading-relaxed">
          {children}
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col gap-3">
          <div className="flex flex-wrap gap-x-4 gap-y-2">
            {legalLinks.map(({ href, label }) => (
              <Link
                key={href}
                to={href}
                className="text-xs text-[#a0a0ab] hover:text-white transition-colors"
              >
                {label}
              </Link>
            ))}
          </div>
          <p className="text-xs text-[#a0a0ab]">© 2026 Kurso — SAS Sanctuaire Consulting Services</p>
        </div>
      </main>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section className="space-y-3">
      <h2 className="text-base font-semibold text-white">{title}</h2>
      <div className="space-y-2 text-[#e8e8e8]">{children}</div>
    </section>
  );
}

export function LegalSubSection({ title, children }) {
  return (
    <div className="space-y-2 ml-4 border-l border-white/10 pl-4">
      <h3 className="text-sm font-medium text-[#e8e8e8]">{title}</h3>
      <div className="text-[#a0a0ab]">{children}</div>
    </div>
  );
}
